// extracted by mini-css-extract-plugin
module.exports = {"collapsable":"Collapsable_collapsable__u5hZP"};